import { useQuery } from '@tanstack/react-query';

import { getLocationTeachersToday } from '../services/locationTeachersService';
import type { LocationTeacherToday } from '../types';

export function useLocationTeachersToday(enabled: boolean) {
  return useQuery<LocationTeacherToday[]>({
    queryKey: ['location-session', 'teachers-today'],
    queryFn: getLocationTeachersToday,
    enabled,
    staleTime: 60 * 1000,
  });
}
